import { ApplicationRef, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { AuthService } from 'src/app/core/auth/auth.service';
import { ResourcesService } from 'src/app/shared/services/resources.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthorizeService } from 'src/app/core/auth/authorize.service';
import { AppSettingsService } from 'src/app/core/app-settings/app-settings.service';

@Component({
  selector: 'app-auto-logout',
  templateUrl: './auto-logout.component.html',
  styleUrls: ['./auto-logout.component.css']
})
export class AutoLogoutComponent implements OnInit {

  resources: any;

  idleMessage : string = '';

  idleMessageWithMinutes : string = ''
  idleMessageWithSeconds : string = ''

  modalRef: NgbModalRef;

  resourceKeyValue: any;

  //Counter for the modal
  counterTimer: number = 0;
  //Countdown time in the modal
  idleCountDownInSeconds: number = 0;
  //Global time for session timeout
  currentSessionTimeout: Date;

  @ViewChild('timeoutTemplate') timeoutModal: TemplateRef<ElementRef>;
  constructor(
    private authorizeService: AuthorizeService,
    private authService: AuthService,
    private idle: Idle,
    private appRef: ApplicationRef,
    private resourcesService: ResourcesService,
    private appSettingsService: AppSettingsService,
    private modalService: NgbModal) {

    //Set Interrupt Resourses as DEFAULT_INTERRUPTSOURCES
    this.setInterruptResources();

    this.idle.onTimeout.subscribe(() => {
      this.logout();
    });

    this.idle.onIdleStart.subscribe(() => {
      //Remove interrupts when the modal is opened
      this.removeInterruptResources();
      this.displayModal();
      //Set the time when the modal is opened
      this.currentSessionTimeout = new Date();
      //Get the global session timeout by sumarize the countdown in the modal
      this.currentSessionTimeout.setSeconds(
        this.currentSessionTimeout.getSeconds() + this.idleCountDownInSeconds + 1
      );
    });

    this.idle.onIdleEnd.subscribe(() => {
      this.resetIdle();
      this.appRef.tick();
    });

    this.idle.onTimeoutWarning.subscribe((countdown: number) => {
      //Get the current time
      var currentTime = new Date();
      //Check if session is expired
      if (currentTime < this.currentSessionTimeout) {
        this.counterTimer = countdown;
        var minutes = ('' + Math.floor(this.counterTimer / 60));
        var seconds = ('' + Math.floor(this.counterTimer % 60)).slice(-2)
        this.idleMessage = this.getIdleMessage(minutes, seconds);
      } else {
        //Case when the user lock the computer and the session timeout has expired
        this.logout();
      }
    });

  }

  ngOnInit() {
    this.resourcesService.bsObject.subscribe(result => {
      result && (this.resourceKeyValue = result);
      this.resources = this.getResources();
      //Get the idlle message to pass the minutes and seconds by parameters
      this.idleMessageWithMinutes = this.resources.idleInstructionMinutes;
      this.idleMessageWithSeconds = this.resources.idleInstructionSeconds;
    });

    //This is the idle time when the user will be logged out
    const sessionIdleTimeout = 60 * this.appSettingsService.sessionIdleTimeout;
    //This is the counter's time that will be shown on the modal
    const idleWarningCounter = 60 * this.appSettingsService.idleWarningCounter;

    //This is the idle time when the modal will be shown
    //If the sesssionIdleTimeout is 30 minutes and the idleWarningCounter is 5 minutes
    //The modal wil be shown after an idle of 25 minutes
    const idleTimeModal = sessionIdleTimeout - idleWarningCounter;

    //The sum of idleTimeModal and idleWarningCounter is the sessionIdleTimeout
    //The next line sets the idle time for the modal
    this.idle.setIdle(idleTimeModal);
    //The next setTimeout function, sum the time to the previous setIdle time
    //To get the total idle timeout (sessionIdleTimeout)
    //If the idleTimeModal is 25 minutes and the idleWarningCounter is 5 minutes
    //The sum of setIdle and setTimeout is the session idle timeout: 30 minutes
    this.idle.setTimeout(idleWarningCounter);

    //Get the modal idle countdown in seconds
    this.idleCountDownInSeconds = idleWarningCounter;
    this.resetIdle();
  }

  setInterruptResources(): void {
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
  }

  removeInterruptResources(): void {
    this.idle.clearInterrupts();
  }

  resetIdle(): void {
    this.counterTimer = 0;
    this.idle.watch();
  }

  stopIdle(): void {
    this.counterTimer = 0;
    this.idle.stop();
  }

  logout(): void {
    this.closeModal();
    this.stopIdle();
    this.authService.logout();
  }

  logoutNotAuthenticated(): void {
    this.stopIdle();
    this.authService.logout();
  }

  displayModal(): void {
    this.modalRef = this.modalService.open(this.timeoutModal, { backdrop: 'static' });
  }

  closeModal(): void {
    this.modalRef.close();
  }

  stay(): void {
    //Set agian the interrupts for continue the session
    this.setInterruptResources();
    this.resetIdle();
  }

  extendSession() {
    //Close the modal idmediatly to prevent an ui bug
    this.closeModal();
    //Async call to check if the user is authenticated
    this.authorizeService.isAuthenticated().subscribe((isAuthenticated: boolean) => {
      if (!isAuthenticated) {
        this.logoutNotAuthenticated();
      } else {
        this.stay();
      }
    });
  }

  getIdleMessage(minutes: string, seconds: string): string {
    if (minutes != "0") {
      return this.idleMessageWithMinutes.replace('{0}',minutes).replace('{1}',seconds);
    } else {
      return this.idleMessageWithSeconds.replace('{0}', seconds);
    }
  }

  private getResources() {
    return {
      title: this.resourceKeyValue.logoutModalTitle,
      idleInstructionMinutes: this.resourceKeyValue.logoutInstructionMinutes,
      idleInstructionSeconds: this.resourceKeyValue.logoutInstructionSeconds,
      idleInstruction: this.resourceKeyValue.logoutInstruction,
      continue: this.resourceKeyValue.logoutContinueBtn,
      logout: this.resourceKeyValue.logoutLogoutBtn
    };
  }
}
